import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'

export default class IsUnlockRecVariantNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()
    const journeyNineVariant = computed(() => flag<string>('outbound-lead-version').value)

    return this.yesNo(journeyNineVariant.value === 'unlock_recommendation')
  }
}
